/* eslint-disable react-hooks/exhaustive-deps */
import { isUndefined, get, isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  createPlacesMultiple,
  getPlaces,
  getPlacesExcelSample,
} from "../../../apis/companies/places";
import { postFilesExcel } from "../../../apis/files";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { download } from "../../../utils/download";
import { excelUploadData } from "../../../utils/excelUploadData";
import { getParams } from "../../../utils/params";
import systemAlert from "../../../utils/systemAlert";

const ManagerWorkPlace = (props) => {
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }));
  const [fields, setFields] = useState([]);
  const [filters] = useState([
    {
      title: '사업장명',
      key: 'search.name',
      type: 'input'
    }
  ])
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      setTargetPermission(permissions.find(p => p.code === 'COMPANY_PLACE_MANAGEMENT'))
    }
  }, [permissions])

  useEffect(() => {
    // 사업장명 name
    // 대표자 leaderEmployee
    // 주소 address addressDetail
    // 전화번호 mobile
    // 운영여부 status 0 폐쇄, 1 운영, 2 휴업
    setFields([
      { title: "사업장명", key: "name" },
      { title: "대표", key: "leaderEmployee" },
      { title: "주소", key: "address" },
      { title: "전화번호", key: "mobile" },
      {
        title: "운영여부",
        key: "status",
        onTranslator: {
          list: [
            { label: "폐쇄", value: 0 },
            { label: "운영", value: 1 },
            { label: "휴업", value: 2 },
          ],
        },
      },
    ]);
  }, []);

  const uploadExcelFile = (e) => {
    const file = e.target.files[0];
    if (!isUndefined(file))
    {
      const formData = new FormData();
      formData.append("file", file);
      postFilesExcel(formData)
        .then((res) => {
          const rows = get(res, "data.sheets[0].rows");
          const keys = [
            { idx: 1, key: "name", type: String },
            { idx: 2, key: "zipCode", type: String },
            { idx: 3, key: "address", type: String },
            { idx: 4, key: "addressDetail", type: String },
            { idx: 5, key: "mobile", type: String },
          ];

          const excelData = {
            places: excelUploadData({ keys, rows }),
          };

          createPlacesMultiple(excelData)
            .then(() => {
              submit();
            })
            .catch((err) => {
              console.error(err.response);
            });
        })
        .catch((err) => {
          console.error(err.response);
        });
    }
  };
  const handleSampleDown = () => {
    getPlacesExcelSample()
      .then((res) => {
        download(res.data.url);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: {
        name: ""
      },
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    setIsLoading(true)
    getPlaces(getParams(params)).then((res) => {
      if (!res) return;
      setTotal(res.data.count);
      setList(res.data.places);
    })
      .catch(() => { })
      .finally(() => { setIsLoading(false) });
  };

  const buttons = [
    {
      label: "삭제",
      color: "gray-line",
      action: () => {
        systemAlert('선택된 사업장 정보를 삭제 하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {

              }
            }
          ]
        })
      },
      isDisabled: isEmpty(selectedList),
    },
    {
      label: "수정하기",
      color: "gray-line",
      action: () => { },
      isDisabled: isEmpty(selectedList) || selectedList.length > 1,
    },
  ];

  const headerButtons = [
    {
      isHide: !(targetPermission.level > 1),
      label: (
        <>
          샘플파일 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      action: handleSampleDown,
    },
    // { label: "인쇄", color: "gray-line", action: () => window.print() },
    {
      isHide: !(targetPermission.level > 1),
      label: "엑셀업로드",
      type: "excelFile",
      onChange: (e) => uploadExcelFile(e),
    },
    {
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      action: () => alert("API 준비중입니다."),
    },
    {
      isHide: !(targetPermission.level > 1),
      label: "사업장 추가",
      action: () => alert("사업장 추가"),
    },
  ];

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <PageHeader title={"사업장 정보 관리"} buttons={headerButtons} />
      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        isControl
        buttons={targetPermission.level > 1 ? buttons : []}
        selectedList={selectedList}
        setSelected={setSelectedList}
        submit={handleSubmit}
      />
    </>
  );
};

export default ManagerWorkPlace;
